<div style="background-color: #F5F7F8; height: 100vh; overflow-y: scroll; padding: 10px; padding-top: 7px; width: 100vw;">
    <img style="width: 22px; height: 22px; position: relative; top: 30px; left: 15px;" (click)="this.back()" src="/assets/images/shared/back.svg">
    <h2 style="text-align: center; margin-top: 3px;">Детайли на поръчката</h2>
    <div style="overflow-y: scroll; margin-bottom: 5px; width: 100%; overflow-x: hidden;">

        <div class="products-container">
            <div *ngFor="let productPerOrg of this.order?.data?.lines">
                <div *ngIf="productPerOrg.state !== 'cancelled'">
                    <div class="row" style="margin: 10px 0 0;" >
                        <label [for]="productPerOrg.uuid">
                            <img [src]="productPerOrg.imageSource" alt="">
                        </label>
                        <div class="col-7 product-container">
                            <p class="product-name" (click)="this.goToProduct(productPerOrg)">{{ productPerOrg.sku.product.name }}</p>
                            <p  *ngIf="productPerOrg.sku?.options?.length" style="font-size: 10px; color: #ADAFBB;"><span *ngFor="let option of productPerOrg.sku?.options || []; index as i"> {{ option.option?.display_name + ': ' + this.returnOptionValue(option) + ((i != productPerOrg.sku.options.length - 1) ? ' | ' : '')}}</span></p>
                            <p *ngIf="!productPerOrg.sku.options.length" style="font-size: 10px; color: #ADAFBB;">&nbsp;</p>
                            <div class="price-container">
                              <div class="order-item-row">
                                <div class="order-item-info">
                                  <app-price
                                    class="order-line-total-price"
                                    [amount]="getLineTotalBase(productPerOrg)"
                                    layout="inline"
                                  ></app-price>

                                  <div
                                    class="order-line-discount-price"
                                    *ngIf="order?.data?.group && shouldShowDiscountPrice(productPerOrg)"
                                  >
                                    <app-price
                                      class="order-line-base-price"
                                      [amount]="getBaseLineTotal(productPerOrg)"
                                      layout="inline"
                                    ></app-price>
                                  </div>

                                  <div class="order-item-subprice">
                                    <span class="order-line-mult">{{ pricingInfoText(productPerOrg) }}</span>
                                    <app-price
                                      class="order-line-unit-price"
                                      [amount]="getUnitPriceBase(productPerOrg)"
                                      layout="inline"
                                    ></app-price>
                                  </div>
                                </div>

                                <div class="quantity">
                                  <span>
                                    <span style="color: #ADAFBB;">Брой: </span>
                                    {{ productPerOrg.quantity }}
                                  </span>
                                </div>
                              </div>
                            </div>
                        </div>
                    </div>
                    <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 18px; margin-bottom: 10px;">
                </div>
            </div>
        </div>
        <div class="products-container" *ngIf="cancelledProductsCount !== 0">
            <div class="row">
                <div class="col-10 d-flex justify-content-start">
                    <h4 class="cancelled-product-tittle">Отказани продукти ({{ cancelledProductsCount }})</h4>
                </div>
                <div class="col-2 d-flex justify-content-end">
                    <span (click)="cancelledProductsModal(content)" class="cancelled-product-icon"><i class="bi bi-info-circle"></i></span>
                    <ng-template #content let-modal>
                        <div class="modal-body">
                            <h4 class="modal-title">Отказани продукти</h4>
                            <div class="modal-body">
                                <p>
                                    Един или повече продукта от Вашата поръчка бяха отказани от търговеца.
                                    Това може да се дължи на недостатъчна наличност или на друга причина.
                                    При нужа от допълнителна информация, моля свържете се директно с търговеца
                                </p>
                            </div>
                        </div>
                        <div class="modal-footer d-flex justify-content-center">
                            <span class="modal-close" (click)="modal.close('Close click')">Разбрах</span>
                        </div>
                    </ng-template>
                </div>
            </div>
            <div *ngFor="let productPerOrg of this.order?.data?.lines; index as i">
                <div *ngIf="productPerOrg.state === 'cancelled'|| productPerOrg.initial_quantity !== productPerOrg.quantity" >
                    <div class="row" style="margin: 10px 0 0;">
                        <label [for]="productPerOrg.uuid">
                            <img [src]="productPerOrg.imageSource" alt="">
                        </label>
                        <div class="col-7 product-container">
                          <p class="product-name" (click)="this.goToProduct(productPerOrg)">{{ productPerOrg.sku.product.name }}</p>
                          <p  *ngIf="productPerOrg.sku?.options?.length" style="font-size: 10px; color: #ADAFBB;"><span *ngFor="let option of productPerOrg.sku?.options || []; index as i"> {{ option.option?.display_name + ': ' + this.returnOptionValue(option) + ((i != productPerOrg.sku.options.length - 1) ? ' | ' : '')}}</span></p>
                          <p *ngIf="!productPerOrg.sku.options.length" style="font-size: 10px; color: #ADAFBB;">&nbsp;</p>
                          <div class="price-container">
                            <div class="order-item-row">
                              <div class="order-item-info">
                                <app-price
                                  class="order-line-total-price"
                                  [amount]="getCancelledLineTotalBase(productPerOrg)"
                                  layout="inline"
                                ></app-price>

                                <div
                                  class="order-line-discount-price"
                                  *ngIf="order?.data?.group && shouldShowDiscountPrice(productPerOrg)"
                                >
                                  <app-price
                                    class="order-line-base-price"
                                    [amount]="getBaseLineTotal(productPerOrg)"
                                    layout="inline"
                                  ></app-price>
                                </div>

                                <div class="order-item-subprice">
                                  <span class="order-line-mult">{{ pricingCancelledInfoText(productPerOrg) }}</span>
                                  <app-price
                                    class="order-line-unit-price"
                                    [amount]="getUnitPriceBase(productPerOrg)"
                                    layout="inline"
                                  ></app-price>
                                </div>
                              </div>

                              <div class="quantity">
                                <span style="color: #c20000;">Отказан</span>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 18px; margin-bottom: 10px;">
                </div>
            </div>
        </div>

        <div style="margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
            <h4 style="font-weight: bold;">Детайли</h4>
            <div class="row" style="margin-top: 12px;">
                <div class="col-6" style="text-align: left;">Статус:</div>
                <div class="col-6" style="text-align: right;">{{ this.orderStatus }}</div>
            </div>
            <div class="row" style="margin-top: 12px;">
                <div class="col-5" style="text-align: left;">Дата:</div>
                <div class="col-7" style="text-align: right;">{{ this.date(this.order?.data?.created_at) }}</div>
            </div>
            <div class="row" style="margin-top: 12px;">
                <div class="col-6" style="text-align: left;">Вид поръчка:</div>
                <div class="col-6" style="text-align: right;">{{ this.groupType }}</div>
            </div>
          <div *ngIf="order?.data?.group" class="row" style="margin-top: 12px;">
            <div class="col-6" style="text-align: left;">Обем на групата:</div>
            <div class="col-6" style="text-align: right;">{{ groupCount }}</div>
          </div>
            <div class="row" style="margin-top: 12px;">
                <div class="col-6" style="text-align: left;">Номер на поръчката:</div>
                <div class="col-6" style="text-align: right;">{{ this.order?.data?.uuid }}</div>
            </div>
            <div class="row" style="margin-top: 12px;">
                <div class="col-4" style="text-align: left;">Метод на плащане:</div>
                <div *ngIf="this.isCOD" class="col-8" style="text-align: right;">Наложен платеж</div>
                <div *ngIf="!this.isCOD && this.paymentIntent" class="col-8" style="text-align: right;">
                    <img *ngIf="this.cardImg" style="width: 44px; height: 44px; margin: 5px; margin-top: 0px;" [src]="this.cardImg" alt="">
                    <p style="padding-left: 0px; display: inline-block;  margin: 5px; font-size: 14px !important;">{{ this.getCardDetail  }}</p>
                </div>
            </div>
            <ng-container *ngFor="let shipment of this.order?.data?.shipment">
              <div *ngIf="shipment.carrier_shipment_identifier" class="row" style="margin-top: 12px;">
                <div class="col-4" style="text-align: left;">Товарителница №:</div>
                <div class="col-8 shipment-content" style="text-align: right;">
                    <a href="https://www.speedy.bg/bg/track-shipment?shipmentNumber={{ shipment.carrier_shipment_identifier }}" target="_blank">
                      {{ shipment.carrier_shipment_identifier }}
                    </a>
                </div>
              </div>
            </ng-container>
        </div>

        <div style="margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
            <h4 style="font-weight: bold;">{{ this.addressSectionTitle }}</h4>
            <p style="margin-bottom: 2px;">{{ this.getAddressName(this.order?.data?.delivery_address) }}</p>
            <p style="margin-bottom: 2px;">{{ this.getAddressPhone(this.order?.data?.delivery_address) }}</p>
            <p>{{ this.getAddressString(this.order?.data?.delivery_address) }}</p>
        </div>

        <div style="margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
            <h4 style="font-weight: bold;">Данни за фактура</h4>
            <p style="margin-bottom: 2px;">{{ this.getAddressName(this.order?.data?.invoice_address) }}</p>
            <p style="margin-bottom: 2px;">{{ this.getAddressPhone(this.order?.data?.invoice_address) }}</p>
            <p>{{ this.getAddressString(this.order?.data?.invoice_address) }}</p>
        </div>

        <div style="margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
            <h4  style="font-weight: bold;">Платена сума</h4>
            <div class="row" style="margin-top: 12px;">
              <div class="col-6" style="text-align: left;">Междинна сума:</div>
              <div class="col-6" style="text-align: right;">
                <app-price
                  [amount]="getSubtotalBase()"
                  layout="inline"
                ></app-price>
              </div>
            </div>
            <div class="row" style="margin-top: 12px;">
              <div class="col-6" style="text-align: left; margin-top: 5px;">Доставка:</div>
              <div class="col-6" style="color: #6FAE2E; text-align: right; margin-top: 5px;">
                <ng-container *ngIf="getShipmentCostBase() > 0; else freeShippingTpl">
                  <app-price
                    [amount]="getShipmentCostBase()"
                    layout="inline"
                    fontWeight="normal"
                  ></app-price>
                </ng-container>
                <ng-template #freeShippingTpl>Безплатна</ng-template>
              </div>
            </div>
            <div *ngIf="order?.data?.group" class="row" style="margin-top: 12px;">
              <div class="col-6" style="text-align: left; margin-top: 5px;">Групова отстъпка:</div>
              <div class="col-6" style="text-align: right;">
                -
                <app-price
                  [amount]="getGroupDiscountBase()"
                  layout="inline"
                  fontWeight="normal"
                ></app-price>
              </div>
            </div>
            <div class="row" style="margin-top: 12px;">
              <div class="col-6" style="text-align: left;">Ваучер:</div>
              <div *ngIf="this.voucherSumAsNumber" class="col-6" style="text-align: right; color: red;">
                -
                <app-price
                  [amount]="voucherSumAsNumber"
                  layout="inline"
                  fontWeight="normal"
                ></app-price>
              </div>
              <div *ngIf="!this.voucherSumAsNumber" class="col-6" style="text-align: right;">-</div>
            </div>
            <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 10px;">
            <div class="row" style="margin-top: 12px;">
              <div class="col-6" style="text-align: left; font-weight: bold;">Общо:</div>
              <div class="col-6" style="text-align: right; font-weight: bold;">
                <app-price
                  [amount]="getOrderGrandTotalBase()"
                  layout="inline"
                ></app-price>
              </div>
            </div>
        </div>
        <div style="bottom: 25px; text-align: center; width: 90%; margin: auto; left: 5%; margin-top: 10px;">
            <button type="button" class="btn btn-primary" [style]="this.btnStyle" (click)="this.return()"> Върни продукт </button>
        </div>
    </div>
</div>
